import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useUserState } from 'contexts/auth-context';

import { Icon } from '../Elements';
import { roundFn } from 'utils/common';

import classes from './Widget.module.scss';

const Widget = ({ title, text, icon, color = 'purple', className }) => {
  const language = useUserState().user.language;

  const counter = roundFn(text, language);

  return (
    <div
      className={cn(
        classes.widget,
        className && className,
        classes[`widget_${color}Before`]
      )}
    >
      <div className={classes.iconWrap}>
        <div className={cn(classes.iconBox, classes[`widget_${color}Bg`])} />
        <Icon icon={icon} className={cn(classes.icon)} />
      </div>

      <div className={classes.info}>
        <h2 className={classes.title}>{title}</h2>
        <p className={cn(classes.text, classes[`widget_${color}Text`])}>
          {counter.number}
          <span className={classes.discriptionNumber}> {counter.text}</span>
        </p>
      </div>
    </div>
  );
};

Widget.propTypes = {
  title: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.object
};

export default Widget;
